import { List, ListItem, styled } from '@mui/material';

export const TaxResidencyInfoList = styled(List)(({ theme }) => ({
  listStyleType: 'disc',
  paddingLeft: theme.spacing(3),
}));

export const TaxResidencyInfoItem = styled(ListItem)(() => ({
  display: 'list-item',
}));
